import { ViewModel,View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { IntegerEditorView } from "./integerEditor-view"

export class IntegerEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new IntegerEditorView();
    }
    public getTypeId(): string {
        return "VM-070963A1-59A0-4AD8-8B0E-F0808DF738DB"
    }

    
    public set value(v: number) { this._value =Math.trunc(getAsNumber(v,true)); } public get value(): number { return this._value;} private _value: number;

    setValue(v: string) {
        this.value = Math.trunc(getAsNumber(v,true));
    }
    getValue(): string {
        return  this.value==null ? null : this.value.toString();
    }
    requestConfirm() {
    }

}
